var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height"},[_c('AppHeader',{attrs:{"enableSearch":true},on:{"moveAddress":_vm.moveAddress,"searchGroup":_vm.searchGroup}}),_c('GoogleMap',{ref:"gmap"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }